import type { BijlageTemplate } from '../../../templates/types/BijlageTemplate'
import type { TemplateSet } from '../types/ContractinstellingenBijlagenSearch'

export { filterTemplatesBySet, getTemplateSetOptions }

const toTemplateSet = ({
  combi,
  typeWerk = [],
}: BijlageTemplate): TemplateSet => {
  const sortedTypeWerk = [...typeWerk].sort()

  return {
    code: [combi, ...sortedTypeWerk].join('|'),
    label: sortedTypeWerk.length
      ? `${combi} - ${sortedTypeWerk.join(' & ')}`
      : combi,
    combi,
    typeWerk: sortedTypeWerk,
  }
}

const getTemplateSetOptions = (templates: BijlageTemplate[]): TemplateSet[] =>
  [
    ...new Map(
      templates.map(toTemplateSet).map((set) => [set.code, set]),
    ).values(),
  ].sort((a, b) => a.label.localeCompare(b.label))

const filterTemplatesBySet = (
  templates: BijlageTemplate[],
  { code }: TemplateSet,
): BijlageTemplate[] =>
  templates.filter((template) => toTemplateSet(template).code === code)
